import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { MOUNTING_INFORMATION, MOUNTING_UNIT_CATEGORY_TYPES } from '@yme/common/constants';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { getAttribute } from '@yme/selectors/products';
import { useTranslation } from '@yme/services/i18n';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { checkPTWAccessories, getMountingInformationTime } from './helpers';
export const MountingInformationComponent = () => {
    const { t } = useTranslation();
    const { isInfiniteDesktopView } = useWindowSize();
    const mountingInformation = useSelector(getAttribute(MOUNTING_INFORMATION));
    const mountingCategories = useSelector(getAttribute(MOUNTING_UNIT_CATEGORY_TYPES));
    const isPTWAccessory = useMemo(() => checkPTWAccessories(mountingCategories ?? []), [mountingCategories]);
    if (!mountingInformation && !isPTWAccessory) {
        return null;
    }
    return (React.createElement(FlexWrapper, { mb: isInfiniteDesktopView ? '32px' : '24px', isFullWidth: true },
        React.createElement(RegularTextLevel3, { weight: 500 },
            t('partsAccessoriesMerch_expectedMountingTime_label'),
            ': ',
            React.createElement(RegularTextLevel3, { weight: 400, as: "span" }, getMountingInformationTime({
                mountingInformation,
                contactDealerLabel: t('partsAccessoriesMerch_contactDealerForExpectedMountingTime_label'),
            })))));
};
